const paywallActionTypes = {
  SET_PAYWALL_USAGE: 'SET_PAYWALL_USAGE',
};
export default paywallActionTypes;
